module.exports = __webpack_public_path__ + "img/rm4.526d6dc1.jpg";